import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Component } from 'react';
import { Card, defaultImageCardDimensions, CardLoading } from '@atlaskit/media-card';
import { FilmstripView } from './filmstripView';
import { generateIdentifierKey } from './utils/generateIdentifierKey';
export var Filmstrip = /*#__PURE__*/function (_Component) {
  _inherits(Filmstrip, _Component);
  var _super = _createSuper(Filmstrip);
  function Filmstrip() {
    var _this;
    _classCallCheck(this, Filmstrip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      animate: false,
      offset: 0
    });
    _defineProperty(_assertThisInitialized(_this), "handleSize", function (_ref) {
      var offset = _ref.offset;
      return _this.setState({
        offset: offset
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (_ref2) {
      var animate = _ref2.animate,
        offset = _ref2.offset;
      return _this.setState({
        animate: animate,
        offset: offset
      });
    });
    return _this;
  }
  _createClass(Filmstrip, [{
    key: "renderCards",
    value: function renderCards() {
      var _this$props = this.props,
        items = _this$props.items,
        mediaClientConfig = _this$props.mediaClientConfig,
        shouldOpenMediaViewer = _this$props.shouldOpenMediaViewer,
        featureFlags = _this$props.featureFlags,
        viewerOptions = _this$props.viewerOptions;
      return items.map(function (item) {
        var key = generateIdentifierKey(item.identifier);
        if (!mediaClientConfig) {
          return /*#__PURE__*/React.createElement(CardLoading, {
            key: key,
            dimensions: defaultImageCardDimensions,
            interactionName: "media-filmstrip-card-loading"
          });
        }
        var mediaViewerItems = shouldOpenMediaViewer ? items.map(function (item) {
          return item.identifier;
        }) : undefined;
        return /*#__PURE__*/React.createElement(Card, _extends({
          key: key,
          mediaClientConfig: mediaClientConfig,
          dimensions: defaultImageCardDimensions,
          useInlinePlayer: false,
          shouldOpenMediaViewer: shouldOpenMediaViewer,
          mediaViewerItems: mediaViewerItems,
          featureFlags: featureFlags,
          viewerOptions: viewerOptions
        }, item));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$testId = this.props.testId,
        testId = _this$props$testId === void 0 ? 'media-filmstrip' : _this$props$testId;
      var _this$state = this.state,
        animate = _this$state.animate,
        offset = _this$state.offset;
      return /*#__PURE__*/React.createElement(FilmstripView, {
        animate: animate,
        offset: offset,
        onSize: this.handleSize,
        onScroll: this.handleScroll,
        testId: testId
      }, this.renderCards());
    }
  }]);
  return Filmstrip;
}(Component);